import { useContext } from "react";
import classnames from "classnames";

import UpdateContext from "context/UpdateContext";
import { Update } from "custom-types/Update";

import DispensaryUpdate from "components/Dispensary/DispensaryUpdate";

const Updates: React.FC<{ className?: string }> = ({ className }) => {
  const {
    selectors: { updates },
  } = useContext(UpdateContext);

  if (!updates || !updates.length) {
    return null;
  }

  return (
    <div className={classnames(className)}>
      <div className="section__header">
        <h3 className="heading--m">Updates</h3>
      </div>
      <div className="row">
        {updates.map((u: Update, i: number) => (
          <div className="lg:col-4 mb-lg" key={i}>
            <DispensaryUpdate update={u} className="bg-leafly-white h-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Updates;
